
export default {
  name: 'CareersSchedule',
  functional: true,
};
